import React, { useContext } from 'react';
import classes from './LoginForm.module.css';
import SessionContext from '../../store/SessionContext';

const LoginForm = props => {

    const session = useContext(SessionContext);

    const enterUsername = (e) => {
        session.handlerUsername(e.target.value);
    }
    const enterPassword = (e) => {
        session.handlerPassword(e.target.value);
    }

    return (
        <div className={classes.formContainer}>
            <h1>Login</h1>
            <form className={classes.form}>
                <input className={classes.input} type='text' placeholder='Username' onChange={enterUsername.bind(this)}></input>
                <input className={classes.input} type='password' placeholder='Password' onChange={enterPassword.bind(this)}></input>
                <button className={classes.button} type='button' onClick={session.loginHandler}>Sign In</button>
            </form>
        </div>

    )
}

export default LoginForm;
